import './App.css';
import React, { useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FormDataContext } from './globalState/FormDataContext';

const ReportingComplete = () => {

  const [formDataState] = useContext(FormDataContext);
  const { answerChecksSubmitted } = formDataState;
  const navigate = useNavigate()

  useEffect(() => {
    if (!answerChecksSubmitted) {
      navigate('/')
    }
  });


  const complete = () => {
    return (
      <main className="wmnds-container">
        <nav aria-label="Breadcrumb" className="wmnds-breadcrumb">
          <ol className="wmnds-breadcrumb__list">
            <li className="wmnds-breadcrumb__list-item">
              <a className="wmnds-breadcrumb__link" href="https://www.tfwm.org.uk/">Home</a>
            </li>
            <li className="wmnds-breadcrumb__list-item">
              <a className="wmnds-breadcrumb__link" href="https://www.tfwm.org.uk/get-help/">Get help</a>
            </li>
            <li className="wmnds-breadcrumb__list-item">
              <Link to="/" className="wmnds-breadcrumb__link">Report a problem with a bus stop or park and ride</Link>
            </li>
            <li className="wmnds-breadcrumb__list-item">
              <span className="wmnds-breadcrumb__link wmnds-breadcrumb__link--current" aria-current="page">Report complete</span>
            </li>
          </ol>
        </nav>
        <div className="wmnds-grid wmnds-p-t-lg">
          <div className="wmnds-col-1 wmnds-col-md-3-4">
            <div className="wmnds-msg-summary wmnds-msg-summary--success-fill-no-icon  wmnds-text-align-center">
              <div className="wmnds-msg-summary__header">
                <h2 className="wmnds-msg-summary__title wmnds-h2 wmnds-p-lg">We've received your form</h2>
              </div>
            </div>
            <h3 className="wmnds-h1">What happens next</h3>
            <p>Thank you for reporting an issue. We will use your report to fix it as soon as possible.</p>
            <p>Please note that response times will vary depending on the nature of the problem reported.</p>
          </div>
        </div>
      </main>
    )
  };

  return (
    complete()
  );
  
}





export default ReportingComplete;
